<template>
    <div :class="$style['inbox-css']">
        <v-card :class="$style['boxMessage']" v-for="item in dataMessage" :key="item.index">
            <div :class="$style['titleMessage']">
                <div style="display: flex; justify-content: space-between;">
                    <span>{{ item.message_title }}</span>
                </div>
                <div :class="$style['dateMessage']" v-if="item.create_at != null">
                    <span v-if="item.create_at != null">{{ oracle.formatDate(item.create_at) }}</span>
                    <v-icon>query_builder</v-icon>
                </div>
            </div>
            <div :class="$style['contentMessage']">
                <span>{{ item.message_body }}</span>
            </div>
        </v-card>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";

    export default {
        name: "MessageProfile",
        data: () => ({
            dataMessage: [],
            oracle: oracle
        }),
        methods: {
            getMessageHand(response) {
                let body = {}
                body.message_title = "به اپلیکیشن کلانا خوش آمدید"
                body.message_body = response.data.message
                if (body.message_body == null || body.message_body == '') {
                    body.message_body = "تازگی و سلامت محصولات کلانا در کنار مزه هایی متفاوت و تنوعی محسوس" +
                        " شامل اسنک، رپ، کوکی، مافین، دسر، سالاد، نوشیدنی سرد و گرم و ... مکمل" +
                        " خوبی برای ارائه این فعالیت جدید است که امیدواریم از طرف شما " +
                        "به عنوان یک سرویس خوب و قابل اطمینان تجربه شود."
                }
                this.dataMessage.push(body)
                oracle.axios("message/getAll", {"limit_by": 500, "offset_by": 0}, this.getMessage);
            },
            getMessage(res) {
                this.dataMessage.push.apply(this.dataMessage, res.data)
                oracle.axios("message/readAll", null);
            },
        },
        mounted() {
            oracle.axios("message/getAll", {"limit_by": 500, "offset_by": 0}, this.getMessageHand);
        },
    };
</script>
<style module>
    .inbox-css .contentMessage {
        text-align: right;
        font-size: 13px !important;
    }

    .inbox-css .titleMessage {
        display: flex;
        justify-content: space-between;
        padding: 5px;
        color: #7ec352;
        font-size: 15px !important;
    }

    .inbox-css .dateMessage {
        font-size: 15px;
        color: #a0a0a0;
        display: flex;

        align-items: center;
    }

    .inbox-css .dateMessage i {
        color: #a0a0a0;
        margin-right: 5px;
        font-size: 16px;
    }

    .inbox-css .boxMessage {
        padding: 10px 15px;
        margin: 10px;
    }
</style>
